export const Menu = {
  // Letra A:
  ACADEMICO: 'Acadêmico',
  ADITIVOS_CONTRATO: 'Aditivos de Contrato',
  AULAS: 'Aulas',
  AVALIACOES: 'Avaliações',
  // Letra B:
  BANCOS: 'Bancos',
  BOLETINS: 'Boletins',
  // Letra C:
  CONFIGURACOES: 'Configurações',
  CONTABIL: 'Contábil',
  CONTRATOS: 'Contratos',
  CURSOS: 'Cursos',
  CURRICULO_ESCOLAR: 'Currículo Escolar',
  CONTAS: 'Contas',
  CONVENIADOS: 'Conveniados',
  COBRANCA: 'Cobrança',

  // Letra D:
  DESCONTOS: 'Descontos',
  DEPOSITOS: 'Depósitos',
  DISCIPLINAS: 'Disciplinas',
  DOCENTES_PERIODO: 'Docentes do Período',
  DOCUMENTO_PADRAO: 'Documento Padrão',
  // Letra E:
  ESTOQUE: 'Estoque',
  // Letra F:
  FINANCEIRO: 'Financeiro',
  FECHAR: 'Fechar',
  FECHAMENTO_PERIODO_LETIVO: 'Fechamento de Período Letivo',
  FECHAMENTO_CURSOS_TURMAS: 'Fechamento de Cursos e Turmas',
  FREQUENCIAS: 'Frequências',
  FORMAS_PAGAMENTO: 'Formas de Pagamento',
  FLUXO_CAIXA: 'Fluxo de Caixa',
  FECHAMENTO_CONTABIL: 'Fechamentos contábil',
  FICHA_SOCIOECONOMICA: 'Relatórios Ficha Socioeconômica',
  FUNCIONARIOS: 'Funcionários',
  FORNECEDORES: 'Fornecedores',
  // Letra G:
  CONSULTA_BOLETOS: 'Consulta de Boletos',
  GERENCIAR_BOLETOS: 'Gerenciar Boletos',
  GERENCIADOR_TURMAS: 'Gerenciador de Turmas',
  GRUPOS_TURMA: 'Grupos de Turma',
  // Letra H:
  HOME: 'Home',
  HISTORICO_ESCOLAR: 'Histórico Escolar',
  HISTORICO_LANCAMENTOS: 'Histórico de Lançamentos',
  // Letra I:
  INSTITUICAO_ENSINO: 'Instituição de Ensino',
  INSTITUICOES_ENSINO: 'Instituições de Ensino',
  INTEGRACAO_FINANCEIRA_CONTABIL: 'Integ. Financeira/Contábil',
  IMPOSTOS: 'Impostos',
  // Letra J:
  // Letra K:
  // Letra L:
  LANCAMENTO_CONTAS_PAGAR: 'Lanç. de Contas a Pagar',
  LANCAMENTO_CONTAS_RECEBER: 'Lanç. de Contas a Receber',
  LANCAMENTOS_CONTABEIS: 'Lançamentos Contábeis',
  LANCAMENTOS_NF: 'Lançamento de Compra',
  // Letra M:
  MATRICULAS: 'Matrículas',
  // Letra N:
  NOTAS: 'Notas',
  // Letra O:
  // Letra P:
  PAINEL_PROFESSOR: 'Painel do Professor',
  PAINEL_COORDENACAO: 'Painel da coordenação',
  PESSOAS: 'Pessoas',
  PERFIS: 'Perfis',
  PERIODO_LETIVO: 'Período Letivo',
  PRECOS: 'Preços',
  PERIODO_FINANCEIRO: 'Período Financeiro',
  PERIODOS_CONTABEIS: 'Períodos Contábeis',
  PLANO_CONTAS: 'Plano de Contas',
  PRODUTOS: 'Produtos',
  PROTOCOLOS: 'Alteração Cadastral',
  // Letra Q:
  // Letra R:
  RELATORIO_DESCONTOS_PARA_CONTRATOS: 'Relatório Descontos para Contratos',
  RELATORIO_BALANCETE: 'Relatório Balancete',
  RELATORIO_DIARIO: 'Relatório Diário',
  RELATORIO_ESTOQUE: 'Relatório Estoque',
  RELATORIO_RAZAO: 'Relatório Razão',
  RELATORIO_FUNCIONARIOS: 'Relatório Funcionários',
  RELATORIO_DISCIPLINA: 'Relatório Disciplina',
  RELATORIO_TURMAS_PARA_ALUNO: 'Relatório Turmas para Aluno',
  RELATORIO_VALORES_PARA_CONTRATOS: 'Relatório Valores para Contratos',
  RELATORIOS_HISTORICO_ESCOLAR: 'Relatórios Baseados em Histórico Escolar',
  RELATORIO_DECLARACAO_IMPOSTO_RENDA: 'Relatório Declaração Imposto de Renda',
  RELATORIO_FATURAMENTO: 'Relatório de Faturamento',
  RECURSOS_HUMANOS: 'Recursos Humanos',
  REMATRICULAS: 'Rematrículas',
  RELATORIOS_TURMAS: 'Relatórios de Turmas',
  RELATORIO_IRMAOS: 'Relatório de Irmãos',
  RELATORIO_TOTALIZADORES: 'Relatório Totalizadores',
  RELATORIO_SITUACAO_CONTRATO: 'Relatórios Situação do Contrato',
  RELATORIO_LANCAMENTOS_POR_PERIODO: 'Relatório Lançamentos por Período',
  IMPRIMIR_RELATORIO_ANALISE_RETROATIVA_CONTAS_RECEBER:
    'Rel. CR. Análises Retroativas Contas a Receber',
  IMPRIMIR_RELATORIO_ANALISE_RETROATIVA_CONTAS_PAGAR:
    'Rel. CP. Análises Retroativas Contas a Pagar',
  // Letra S:
  SUPRIMENTOS: 'Suprimentos',

  // Letra T:
  TURMAS: 'Turmas',
  TIPO_DE_AVALIACAO: 'Tipo de avaliações',
  // Letra U:
  USUARIOS: 'Usuários',

  // Letra V:
  // Letra X:
  // Letra Y:
  // Letra Z:
};
